import { Component, OnInit, Input } from "@angular/core";
import { AlertService } from "../../_services/alert.service";
import { DataService } from "../../_services/data.service";

@Component({
  moduleId: module.id,
  selector: "app-content-editor",
  templateUrl: "content.component.html",
})
export class ContentComponent implements OnInit {
  loading = false;
  model: any = {};
  messages: any;
  definitions: any = [];
  selectedCircle: any;

  constructor(
    private dataService: DataService,
    private alertService: AlertService
  ) {
    this.messages = JSON.parse(localStorage.getItem("messages"));
  }

  getTextWithCircle(circles, textDefinition) {
    const newCirlces = [];

    if (circles && circles.length) {
      circles.forEach((c) => {
        if (textDefinition.circleId === c.circleId) {
          newCirlces.push({
            circleId: c.circleId,
            circleName: c.circleName,
            divText: textDefinition.divText,
            definitionId: textDefinition.definitionId,
            id: textDefinition.id,
          });
        } else {
          newCirlces.push(c);
        }
      });
    }
    return newCirlces;
  }

  getDefinitionById(id) {
    let resp;
    if (this.definitions && this.definitions.length) {
      this.definitions.forEach((def) => {
        if (def.definitionId === id) {
          resp = def;
        }
      });
    }
    return resp;
  }

  beforeChange(event) {
    this.selectedCircle = undefined;
    if (this.definitions && this.definitions.length) {
      this.definitions.forEach((definition) => {
        if (definition && definition.circles && definition.circles.length) {
          definition.circles.forEach((c) => {
            c["isSelected"] = false;
          });
        }
      });
    }
  }

  saveRecord() {
    this.dataService.saveContentCircle(this.selectedCircle).subscribe(
      (data) => {
        this.loading = false;
        this.alertService.success("נשמר בהצלחה");
        this.selectedCircle.divText = this.selectedCircle.divTextNew;
        if (data && data.newId) {
          this.selectedCircle["id"] = data.newId;
          const def = this.getDefinitionById(this.selectedCircle.definitionId);
          if (def && def.circles && def.circles.length) {
            def.circles.forEach((c) => {
              if (c.circleId === this.selectedCircle.circleId) {
                c["divText"] = this.selectedCircle.divText;
                c["definitionId"] = this.selectedCircle.definitionId;
                c["id"] = data.newId;
              }
            });
          }
        }
      },
      (error) => {
        const body = error.json && error.json();
        this.alertService.error(
          body && body.statusText
            ? this.messages[body.statusText]
              ? this.messages[body.statusText]
              : decodeURIComponent(body.statusText)
            : (error && error.statusText) || error
        );
        this.loading = false;
      }
    );
  }

  selectCircle(circle, definition) {
    if (definition && definition.circles && definition.circles.length) {
      definition.circles.forEach((c) => {
        c["isSelected"] = false;
      });
    }
    circle["isSelected"] = true;
    this.selectedCircle = circle;
    if (this.selectedCircle["id"] === undefined) {
      this.selectedCircle["divText"] = "";
      this.selectedCircle["divTextNew"] = "";
      this.selectedCircle["definitionId"] = definition.definitionId;
    } else {
      this.selectedCircle["divTextNew"] = this.selectedCircle["divText"];
    }
  }

  ngOnInit() {
    this.loading = true;
    this.dataService.getContentData().subscribe(
      (data) => {
        this.loading = false;
        this.model = data;
        if (data && data.texts && data.texts.length) {
          data.texts.forEach((t) => {
            const def = this.getDefinitionById(t.definitionId);
            if (!def) {
              this.definitions.push({
                definitionId: t.definitionId,
                divId: t.divId,
                name: t.name,
                circles: this.getTextWithCircle(data.circles, t),
              });
            } else {
              def["circles"] = this.getTextWithCircle(def.circles, t);
            }
          });
        }
      },
      (error) => {
        this.alertService.error(
          error && error.statusText
            ? decodeURIComponent(error.statusText)
            : error
        );
        this.loading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/content/content.component.ts